<template>
    <VTextField
        ref="inputRef"
        :value="value"
        v-bind="$attrs"
        :class="classList"
        :rules="validationRules"
        :outlined="outlined"
        :hint="hint"
        :persistent-hint="persistentHint"
        :suffix="suffix"
        :disabled="disabled"
        :dense="compact"
        v-on="$listeners"
        @blur="setWasFocused"
        @input="emitInput"
        @update:error="emitHasError"
    >
        <template v-if="hasPrependedIcon" #prepend-inner>
            <SrIcon size="s" :icon="prependIcon" class="mr-3 mt-1" @click="$emit('click:prepend')" />
        </template>
        <template v-if="shouldDisplayLabel" #label>
            <SrInputLabel :label="label" :required="required" />
        </template>
        <template #append>
            <SrInputValidIndicator v-if="showIsValidIndicator" :is-valid="wasFocused && isInputValid" />
            <SrIcon v-if="hasAppendedIcon" size="s" :icon="appendIcon" class="mr-3 mt-1" @click="$emit('click:append')" />
        </template>
    </VTextField>
</template>

<script>
// https://vuetifyjs.com/en/components/text-fields#text-fields

import { USER_INPUT_CLASS } from '../../utils/classNames';
import { getInputRules } from '../../rules';
import PropagateInputEvent from '../../mixins/PropagateInputEvent';
import SrInputValidIndicator from './SrInputValidIndicator';
import { SrInputLabel } from '../SrInputLabel';
import { SrIcon } from '../SrIcon';

const ELEMENT_CLASS = 'sr-input';

export default {
    name: 'SrInput',
    components: {
        SrInputLabel,
        SrInputValidIndicator,
        SrIcon,
    },
    mixins: [PropagateInputEvent],
    props: {
        value: {
            type: [String, Number],
            default: '',
        },
        label: {
            type: String,
            default: '',
        },
        suffix: {
            type: String,
            required: false,
        },
        hint: {
            type: String,
            required: false,
        },
        persistentHint: {
            type: Boolean,
            default: false,
        },
        required: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        outlined: {
            type: Boolean,
            default: true,
        },
        compact: {
            type: Boolean,
            default: false,
        },
        rules: {
            type: Array,
            default: () => [],
        },
        showIsValidIndicator: {
            type: Boolean,
            default: false,
        },
        prependIcon: {
            type: String,
            default: '',
        },
        appendIcon: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            wasFocused: false,
        };
    },
    computed: {
        validationRules() {
            return getInputRules(this.rules, this.required);
        },
        isInputValid() {
            return this.$refs.inputRef?.valid;
        },
        hasPrependedIcon() {
            return Boolean(this.prependIcon);
        },
        hasAppendedIcon() {
            return Boolean(this.appendIcon);
        },
        classList() {
            return {
                [ELEMENT_CLASS]: true,
                [USER_INPUT_CLASS]: true,
                'has-prepend-icon': this.hasPrependedIcon,
                'has-append-icon': this.hasAppendedIcon,
            };
        },
        shouldDisplayLabel() {
            return this.label || this.required;
        },
    },
    methods: {
        setWasFocused() {
            this.wasFocused = true;
        },
        emitHasError(hasError) {
            this.$emit('update:error', hasError);
        },
    },
};
</script>
